import { getEmailRegex } from 'hb-react/shared/constants/emailRegex';
import isValueEmpty from 'hb-react/shared/utils/isValueEmpty';

const emailRegex = getEmailRegex();

export const validateEmailsInline = (value) => {
  let error;

  if (isValueEmpty(value)) {
    return error;
  }

  const emailsSplit = value.replace(/\s*/g, '').split(',' || ';');

  emailsSplit.forEach((email) => {
    if (!emailRegex.test(email)) {
      error = n__(
        'Must be a valid email',
        'Must be valid emails',
        emailsSplit.length,
      );
    }
  });

  return error;
};
